import React from 'react';
import { DownloadIcon } from 'lucide-react';
import type { DownloadItem } from '../../data/media';
type DownloadCardProps = {
  item: DownloadItem;
};
export function DownloadCard({
  item
}: DownloadCardProps) {
  return <article className="flex h-full flex-col overflow-hidden rounded-card border border-sand-200 bg-white" data-id="element-586" data-mp="147ffzfdwtjmn">
      <img src={item.thumbnail} alt="" loading="lazy" className="aspect-[4/3] w-full object-cover" data-id="element-587" data-mp="194o03limbxqj" />
      <div className="flex flex-1 flex-col p-5" data-id="element-588" data-mp="ggjsgughlal7">
        <span className="text-[11px] font-bold uppercase tracking-[0.1em] text-green-700" data-id="element-589" data-mp="ghbd5a8jpnwp">
          {item.type}
        </span>
        <h3 className="mt-1.5 font-display text-[18px] leading-snug text-ink" data-id="element-590" data-mp="lhpmqwpsp5wu">{item.title}</h3>
        <p className="mt-1.5 text-[13px] text-slate-500" data-id="element-591" data-mp="qg0xd9nwzkg4">{item.meta}</p>
        <p className="mt-3 text-[13px] leading-relaxed text-slate-600" data-id="element-592" data-mp="1wtqiivl2tum3">{item.usage}</p>
        <button type="button" className="mt-auto inline-flex h-10 w-full items-center justify-center gap-2 rounded-lg border border-sand-300 pt-0 text-[14px] font-semibold text-ink transition-colors duration-150 ease-emphasis hover:border-green-600 hover:text-green-700" data-id="element-593" data-mp="21t3cs1ea23yp">
          <DownloadIcon aria-hidden className="h-4 w-4" data-id="element-594" data-mp="14jhy7e6jx2z" />
          Download
        </button>
      </div>
    </article>;
}